import { render, staticRenderFns } from "./DistributionContainer.vue?vue&type=template&id=840c13fe&scoped=true"
import script from "./DistributionContainer.vue?vue&type=script&lang=js"
export * from "./DistributionContainer.vue?vue&type=script&lang=js"
import style0 from "./DistributionContainer.vue?vue&type=style&index=0&id=840c13fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840c13fe",
  null
  
)

export default component.exports